/* Contador de árboles Eden compartido por eden-live-ticker y eden-home-impact.
   Valor = interpolación lineal entre data-from (en data-t0) y data-to (en data-t1), igual que la landing.
   Marcado dentro de [data-eden-counter]:
     [data-eden-num="roll"|"plain"]  número (roll = columnas de dígitos que ruedan)
     [data-eden-fill]                barra de progreso (width %)
     [data-eden-tpl="..."]           texto con [percent] [remaining] [goal] [next]
     [data-eden-pop]                 contenedor donde aparece "+1" en cada árbol nuevo */
(function () {
  if (window.EdenCounter) return;
  var lang = (document.documentElement.lang || 'en').replace('_', '-');
  var fmt = new Intl.NumberFormat(lang);
  var dec = new Intl.NumberFormat(lang, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function num(root, k) { return parseFloat(root.dataset[k]) || 0; }

  function current(root) {
    var from = num(root, 'from'), to = num(root, 'to'), t0 = num(root, 't0') * 1000, t1 = num(root, 't1') * 1000, now = Date.now();
    if (!t0 || !t1 || t1 <= t0 || now <= t0) return from;
    if (now >= t1) return to;
    return Math.floor(from + (to - from) * (now - t0) / (t1 - t0));
  }

  function buildRoll(el, str) {
    el.innerHTML = '';
    for (var i = 0; i < str.length; i++) {
      var ch = str[i], s = document.createElement('span');
      if (/\d/.test(ch)) {
        s.className = 'ec-d';
        s.innerHTML = '<span>' + '0123456789'.split('').map(function (x) { return '<i>' + x + '</i>'; }).join('') + '</span>';
      } else { s.className = 'ec-s'; s.textContent = ch; }
      el.appendChild(s);
    }
  }

  function paintRoll(el, str) {
    if (el.children.length !== str.length || !el.querySelector('.ec-d')) buildRoll(el, str);
    for (var i = 0; i < str.length; i++) {
      if (/\d/.test(str[i])) el.children[i].firstChild.style.transform = 'translateY(-' + (+str[i] * 10) + '%)';
    }
  }

  function init(root) {
    if (!root || root.dataset.ecInit) return;
    root.dataset.ecInit = 1;
    var goal = num(root, 'goal') || num(root, 'to');
    var nums = root.querySelectorAll('[data-eden-num]');
    var fills = root.querySelectorAll('[data-eden-fill]');
    var tpls = root.querySelectorAll('[data-eden-tpl]');
    var pops = root.querySelectorAll('[data-eden-pop]');
    var last = -1;

    function paint(v) {
      var str = fmt.format(v);
      nums.forEach(function (el) {
        if (el.dataset.edenNum === 'roll') paintRoll(el, str); else el.textContent = str;
        el.setAttribute('aria-label', str);
      });
      var pct = Math.min(100, v / goal * 100);
      fills.forEach(function (f) { f.style.width = pct.toFixed(2) + '%'; });
      var rep = { percent: dec.format(Math.floor(pct * 10) / 10), remaining: fmt.format(Math.max(0, goal - v)), goal: fmt.format(goal), next: fmt.format(v + 1) };
      tpls.forEach(function (t) {
        t.innerHTML = t.dataset.edenTpl.replace(/\[(\w+)\]/g, function (a, k) { return '<b>' + (rep[k] != null ? rep[k] : a) + '</b>'; });
      });
    }

    function pop() {
      if (reduced) return;
      pops.forEach(function (p) {
        var b = document.createElement('span');
        b.className = 'ec-pop';
        b.textContent = '+1';
        p.appendChild(b);
        setTimeout(function () { b.remove(); }, 1800);
      });
    }

    function tick() {
      var v = current(root);
      if (v === last) return;
      if (last !== -1 && v > last) pop();
      paint(v); last = v;
    }

    function start() {
      if (root.dataset.ecStarted) return;
      root.dataset.ecStarted = 1;
      root.classList.add('ec-on');
      tick();
      setInterval(tick, 1000);
    }

    // Estado inicial: odómetro a 0 para que ruede al entrar en pantalla (el texto accesible ya lleva el valor real).
    var initial = fmt.format(current(root));
    nums.forEach(function (el) {
      if (el.dataset.edenNum === 'roll' && !reduced) buildRoll(el, initial);
      el.setAttribute('aria-label', initial);
    });
    if (reduced || !('IntersectionObserver' in window) || root.hasAttribute('data-eden-now')) { start(); return; }
    var io = new IntersectionObserver(function (e) {
      if (e[0].isIntersecting) { io.disconnect(); requestAnimationFrame(function () { requestAnimationFrame(start); }); }
    }, { threshold: 0.3 });
    io.observe(root);
  }

  window.EdenCounter = { init: init, current: current };
  function boot() { document.querySelectorAll('[data-eden-counter]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Editor de temas: re-inicializar al recargar la sección
  document.addEventListener('shopify:section:load', boot);
  // El carrito se vuelve a pintar por innerHTML al añadir/cambiar productos: inicializar los contadores nuevos
  var queued = false;
  new MutationObserver(function () {
    if (queued) return; queued = true;
    requestAnimationFrame(function () { queued = false; document.querySelectorAll('[data-eden-counter]:not([data-ec-init])').forEach(init); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
